<form id="parkerEndSubscriptionForm" [formGroup]="parkerSubscriptionForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label class="control-label required">{{'i18n.domain.parker-administration.detail.form.subscription' | translate}}</label>
      <ejs-dropdownlist id="subscription"
                        [dataSource]="subscriptionsDropdownValues"
                        [fields]="dropdownSettings"
                        [showClearButton]="true"
                        formControlName="subscriptionId"></ejs-dropdownlist>

      <app-error-messages [control]="parkerSubscriptionForm.controls.subscriptionId"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
  <div class="form-group col-md-6">

      <label class="d-block">{{'i18n.domain.parker-administration.overview.function-dialog.function-form.end-subscription.end-immediately' | translate}}</label>
      <app-yes-no-group-button id="isToDateImmediate"
                               [(ngModel)]="isToDateImmediate"
                               (change)="handleDateField(isToDateImmediate)"
                               [ngModelOptions]="{standalone: true}"></app-yes-no-group-button>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label"
             [ngClass]="{'required': !isToDateImmediate}">{{'i18n.domain.parker-administration.detail.form.validTo' | translate}}</label>
      <ejs-datetimepicker id="validTo"
                          formControlName="validTo"
                          timeFormat="HH:mm"
                          format="dd.MM.yyyy HH:mm"
                          [min]="minDate">
      </ejs-datetimepicker>
      <app-error-messages [control]="parkerSubscriptionForm.controls.validTo"></app-error-messages>
    </div>
  </div>
</form>
